// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-view-widget-design[data-v-a2caf60c]{width:100%;height:100%;position:fixed;right:0;top:0;bottom:0;z-index:1020}.el-header-dv[data-v-a2caf60c]{background:#fff}", ""]);
// Exports
module.exports = exports;
